import { Component } from '@angular/core';
import { StatusButtons } from "../../../_shared/interfaces";
import { NgForOf } from "@angular/common";
import { JobsOverviewComponent } from "./jobs-overview/jobs-overview.component";

@Component({
  selector: 'app-jobs',
  standalone: true,
  imports: [
    NgForOf,
    JobsOverviewComponent,
  ],
  templateUrl: './jobs.component.html',
  styleUrl: './jobs.component.sass'
})

export class JobsComponent {
  status: string = 'running';

  statusButtons: StatusButtons[] = [
    { state: 'all', display: 'Alle', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'standard', display: 'Standard', label: 'alert-info', icon: 'info-circle'},
    { state: 'confirmed', display: 'Auftrag bestätigt', label: 'label-success', icon: 'check-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'info-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-danger', icon: 'check-circle'},
    { state: 'finished', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor() { }

  changeOverviewStatus(statusIndex: number){
    this.status = this.statusButtons[statusIndex].state;
  }

}
